/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VisitorSessionVariable
 */
export interface VisitorSessionVariable {
    /**
     * 
     * @type {string}
     * @memberof VisitorSessionVariable
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VisitorSessionVariable
     */
    value?: string;
}

export function VisitorSessionVariableFromJSON(json: any): VisitorSessionVariable {
    return VisitorSessionVariableFromJSONTyped(json, false);
}

export function VisitorSessionVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitorSessionVariable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function VisitorSessionVariableToJSON(value?: VisitorSessionVariable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}


